var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebForm4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.12 324.088C382.512 298.24 387.84 262.4 384.8 232C383.296 216.936 380.352 201.144 371.456 188.52C358.496 170.12 337.104 160.456 320.8 145.6C296.8 123.744 286.648 91.8317 266.232 67.1997C239.584 35.1117 197.6 31.0557 158.32 32.9517C128.8 34.3997 81.3438 34.9597 74.3998 71.9997C67.1998 110.4 80.7998 146.4 51.9998 164.8C23.1998 183.2 7.99976 221.6 16.7998 254.4C24.2238 282.064 59.8078 286.96 67.1998 315.2C75.9998 348.8 127.2 393.6 176.8 390.4C226.4 387.2 255.2 354.4 276 356C300.104 357.848 325.784 357.776 346.048 342.712C353.009 337.488 359.108 331.203 364.12 324.088Z",
    fill: "#407BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M364.12 324.088C382.512 298.24 387.84 262.4 384.8 232C383.296 216.936 380.352 201.144 371.456 188.52C358.496 170.12 337.104 160.456 320.8 145.6C296.8 123.744 286.648 91.8317 266.232 67.1997C239.584 35.1117 197.6 31.0557 158.32 32.9517C128.8 34.3997 81.3438 34.9597 74.3998 71.9997C67.1998 110.4 80.7998 146.4 51.9998 164.8C23.1998 183.2 7.99976 221.6 16.7998 254.4C24.2238 282.064 59.8078 286.96 67.1998 315.2C75.9998 348.8 127.2 393.6 176.8 390.4C226.4 387.2 255.2 354.4 276 356C300.104 357.848 325.784 357.776 346.048 342.712C353.009 337.488 359.108 331.203 364.12 324.088Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M328.551 108.848C328.551 108.848 313.279 100.36 312.151 119.592C311.023 138.824 308.191 263.8 308.191 263.8",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M304.224 121.288C304.224 121.288 316.68 149 311.024 262.088",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.456 112.712C316.456 112.712 310.616 116.456 307.296 112.176C303.976 107.896 309.544 100.048 304.632 96.6883C299.72 93.3283 291.24 98.4563 291.24 98.4563C291.24 98.4563 297.776 100.376 297.56 103.936C297.344 107.496 294.208 108.848 293.792 107.288C293.376 105.728 290.256 97.8883 284.952 101.152C283.425 102.056 282.096 103.258 281.046 104.688C279.995 106.118 279.245 107.745 278.84 109.472C278.84 109.472 291.2 108.16 291.928 112.8C292.656 117.44 286.872 112 281.776 111.688C276.68 111.376 272.048 112.136 272.376 115.224C272.704 118.312 271.896 123.368 271.896 123.368C271.896 123.368 276.208 119.536 281.808 119.864C287.408 120.192 287.2 123.76 282.104 123.464C277.008 123.168 272.64 128 272.64 128C272.64 128 277.28 135.936 283.184 139.856C289.088 143.776 291.184 142.376 291.896 139.352C292.608 136.328 291 128.568 294.56 128.776C298.12 128.984 288.664 142.224 293.216 143C297.768 143.776 301.416 142.464 302.616 139.472L303.816 136.48C303.816 136.48 302.216 128.72 302.92 125.696C303.624 122.672 304.448 125.784 305.256 129.408C306.064 133.032 306.568 141.752 308.128 141.328C309.688 140.904 314.656 134.56 315.824 132.08C316.992 129.6 309.272 121.984 309.36 120.456C309.448 118.928 315.408 121.832 316.336 123.424C317.008 124.618 317.617 125.846 318.16 127.104C318.16 127.104 321.88 124.768 321.792 117.616C321.704 110.464 316.456 112.712 316.456 112.712Z",
    fill: "#407BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M316.456 112.712C316.456 112.712 310.616 116.456 307.296 112.176C303.976 107.896 309.544 100.048 304.632 96.6883C299.72 93.3283 291.24 98.4563 291.24 98.4563C291.24 98.4563 297.776 100.376 297.56 103.936C297.344 107.496 294.208 108.848 293.792 107.288C293.376 105.728 290.256 97.8883 284.952 101.152C283.425 102.056 282.096 103.258 281.046 104.688C279.995 106.118 279.245 107.745 278.84 109.472C278.84 109.472 291.2 108.16 291.928 112.8C292.656 117.44 286.872 112 281.776 111.688C276.68 111.376 272.048 112.136 272.376 115.224C272.704 118.312 271.896 123.368 271.896 123.368C271.896 123.368 276.208 119.536 281.808 119.864C287.408 120.192 287.2 123.76 282.104 123.464C277.008 123.168 272.64 128 272.64 128C272.64 128 277.28 135.936 283.184 139.856C289.088 143.776 291.184 142.376 291.896 139.352C292.608 136.328 291 128.568 294.56 128.776C298.12 128.984 288.664 142.224 293.216 143C297.768 143.776 301.416 142.464 302.616 139.472L303.816 136.48C303.816 136.48 302.216 128.72 302.92 125.696C303.624 122.672 304.448 125.784 305.256 129.408C306.064 133.032 306.568 141.752 308.128 141.328C309.688 140.904 314.656 134.56 315.824 132.08C316.992 129.6 309.272 121.984 309.36 120.456C309.448 118.928 315.408 121.832 316.336 123.424C317.008 124.618 317.617 125.846 318.16 127.104C318.16 127.104 321.88 124.768 321.792 117.616C321.704 110.464 316.456 112.712 316.456 112.712Z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M286.848 129.496C290.656 124.792 296.272 118.416 300.976 115.376",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M282.399 135.201C282.399 135.201 283.375 133.841 284.959 131.801",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M303.456 116.544C303.456 116.544 309.12 124.544 310.168 132.784",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M297.048 121.28C297.048 121.28 298.648 120.352 298.04 130.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M301.184 111.817C301.184 111.817 304.384 108.945 302.712 103.217",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M296.808 116.664L294.504 112.44",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M292 120.976C292 120.976 284.664 115.432 280.08 115.168",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M337.271 97.6004C337.271 97.6004 337.039 106 330.487 106.4C323.935 106.8 319.879 95.8804 313.167 98.5124C306.455 101.144 305.815 113.12 305.815 113.12C305.815 113.12 312.215 107.888 315.607 110.528C318.999 113.168 318.239 117.24 316.407 116.592C314.575 115.944 304.583 113.72 304.239 121.256C304.102 123.401 304.401 125.552 305.118 127.579C305.834 129.605 306.953 131.466 308.407 133.048C308.407 133.048 315.503 119.792 320.655 122.208C325.807 124.624 316.399 126.728 312.655 131.616C308.911 136.504 306.471 141.672 309.783 143.44C313.095 145.208 317.615 149.472 317.615 149.472C317.615 149.472 316.719 142.544 320.863 137.16C325.007 131.776 328.439 134.424 324.663 139.312C320.887 144.2 322.767 151.888 322.767 151.888C322.767 151.888 333.879 152.688 341.831 149.424C349.783 146.16 349.831 143.104 347.263 140.352C344.695 137.6 335.855 133.904 338.463 130.472C341.071 127.04 347.903 145.552 351.783 141.52C355.663 137.488 356.839 132.944 354.663 129.696L352.479 126.496C352.479 126.496 343.631 122.8 341.071 120.048C338.511 117.296 342.207 118.576 346.383 120.24C350.559 121.904 359.631 127.336 360.279 125.488C360.927 123.64 357.951 114.336 356.279 111.472C354.607 108.608 341.703 111.16 340.231 110.032C338.759 108.904 345.735 104.912 347.959 105.064C349.615 105.206 351.263 105.433 352.895 105.744C352.895 105.744 353.087 100.44 345.855 95.6484C338.623 90.8564 337.271 97.6004 337.271 97.6004Z",
    fill: "#407BFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M337.271 97.6004C337.271 97.6004 337.039 106 330.487 106.4C323.935 106.8 319.879 95.8804 313.167 98.5124C306.455 101.144 305.815 113.12 305.815 113.12C305.815 113.12 312.215 107.888 315.607 110.528C318.999 113.168 318.239 117.24 316.407 116.592C314.575 115.944 304.583 113.72 304.239 121.256C304.102 123.401 304.401 125.552 305.118 127.579C305.834 129.605 306.953 131.466 308.407 133.048C308.407 133.048 315.503 119.792 320.655 122.208C325.807 124.624 316.399 126.728 312.655 131.616C308.911 136.504 306.471 141.672 309.783 143.44C313.095 145.208 317.615 149.472 317.615 149.472C317.615 149.472 316.719 142.544 320.863 137.16C325.007 131.776 328.439 134.424 324.663 139.312C320.887 144.2 322.767 151.888 322.767 151.888C322.767 151.888 333.879 152.688 341.831 149.424C349.783 146.16 349.831 143.104 347.263 140.352C344.695 137.6 335.855 133.904 338.463 130.472C341.071 127.04 347.903 145.552 351.783 141.52C355.663 137.488 356.839 132.944 354.663 129.696L352.479 126.496C352.479 126.496 343.631 122.8 341.071 120.048C338.511 117.296 342.207 118.576 346.383 120.24C350.559 121.904 359.631 127.336 360.279 125.488C360.927 123.64 357.951 114.336 356.279 111.472C354.607 108.608 341.703 111.16 340.231 110.032C338.759 108.904 345.735 104.912 347.959 105.064C349.615 105.206 351.263 105.433 352.895 105.744C352.895 105.744 353.087 100.44 345.855 95.6484C338.623 90.8564 337.271 97.6004 337.271 97.6004Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M333.895 138.712C331.775 131.688 329.223 121.728 329.383 114.944",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M336.624 147.04C336.624 147.04 335.928 145.136 334.968 142.16",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.248 113.249C332.248 113.249 344.112 113.041 353.048 117.601",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M332.615 122.897C332.615 122.897 332.767 120.673 342.559 128.217",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M325.959 112.304C325.959 112.304 325.287 107.104 318.399 104.912",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M327.84 119.992L322.04 119.416",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M328.847 127.784C328.847 127.784 318.295 131.352 314.903 135.784",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M266.911 153.521C266.911 153.521 300.279 175.577 299.711 260.969",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M308.048 147.696C308.048 147.696 306.984 157.368 299.384 157.216C291.784 157.064 288.136 144.08 280.144 146.48C272.152 148.88 270.28 162.64 270.28 162.64C270.28 162.64 278.12 157.208 281.824 160.576C285.528 163.944 284.224 168.576 282.16 167.648C280.096 166.72 268.8 163.2 267.68 171.872C267.316 174.336 267.456 176.847 268.091 179.255C268.727 181.663 269.844 183.917 271.376 185.88C271.376 185.88 280.808 171.256 286.536 174.528C292.264 177.8 281.192 179.328 276.376 184.632C271.56 189.936 268.288 195.64 271.944 198C275.6 200.36 280.408 205.704 280.408 205.704C280.408 205.704 280 197.6 285.32 191.8C290.64 186 294.32 189.352 289.504 194.64C284.688 199.928 286.136 208.976 286.136 208.976C286.136 208.976 298.88 210.904 308.36 207.928C317.84 204.952 318.176 201.392 315.48 197.968C312.784 194.544 302.928 189.448 306.304 185.752C309.68 182.056 315.768 204.032 320.632 199.752C325.496 195.472 327.272 190.328 325.064 186.384L322.848 182.44C322.848 182.44 312.992 177.336 310.296 173.912C307.6 170.488 311.744 172.312 316.408 174.64C321.072 176.968 331.032 184.072 331.944 182.008C332.856 179.944 330.344 168.92 328.632 165.456C326.92 161.992 311.832 163.72 310.232 162.256C308.632 160.792 317.064 156.872 319.616 157.256C321.503 157.58 323.372 157.999 325.216 158.512C325.216 158.512 325.944 152.4 318.056 146.192C310.168 139.984 308.048 147.696 308.048 147.696Z",
    fill: "#407BFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M308.048 147.696C308.048 147.696 306.984 157.368 299.384 157.216C291.784 157.064 288.136 144.08 280.144 146.48C272.152 148.88 270.28 162.64 270.28 162.64C270.28 162.64 278.12 157.208 281.824 160.576C285.528 163.944 284.224 168.576 282.16 167.648C280.096 166.72 268.8 163.2 267.68 171.872C267.316 174.336 267.456 176.847 268.091 179.255C268.727 181.663 269.844 183.917 271.376 185.88C271.376 185.88 280.808 171.256 286.536 174.528C292.264 177.8 281.192 179.328 276.376 184.632C271.56 189.936 268.288 195.64 271.944 198C275.6 200.36 280.408 205.704 280.408 205.704C280.408 205.704 280 197.6 285.32 191.8C290.64 186 294.32 189.352 289.504 194.64C284.688 199.928 286.136 208.976 286.136 208.976C286.136 208.976 298.88 210.904 308.36 207.928C317.84 204.952 318.176 201.392 315.48 197.968C312.784 194.544 302.928 189.448 306.304 185.752C309.68 182.056 315.768 204.032 320.632 199.752C325.496 195.472 327.272 190.328 325.064 186.384L322.848 182.44C322.848 182.44 312.992 177.336 310.296 173.912C307.6 170.488 311.744 172.312 316.408 174.64C321.072 176.968 331.032 184.072 331.944 182.008C332.856 179.944 330.344 168.92 328.632 165.456C326.92 161.992 311.832 163.72 310.232 162.256C308.632 160.792 317.064 156.872 319.616 157.256C321.503 157.58 323.372 157.999 325.216 158.512C325.216 158.512 325.944 152.4 318.056 146.192C310.168 139.984 308.048 147.696 308.048 147.696Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M300.271 194.785C298.487 186.481 296.487 174.785 297.311 166.937",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M302.639 204.656C302.639 204.656 302.015 202.392 301.191 198.864",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M300.8 165.248C300.8 165.248 314.512 166.12 324.416 172.24",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M300.287 176.416C300.287 176.416 300.679 173.864 311.255 183.488",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M293.6 163.568C293.6 163.568 293.32 157.504 285.6 154.328",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M295.047 172.608L288.407 171.4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M295.48 181.704C295.48 181.704 282.968 184.8 278.64 189.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M279.92 220.8C279.92 220.8 301.408 237.2 303.672 261.52L299.144 180.088",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M307.063 260.968C307.063 260.968 290.663 141.648 338.167 141.648",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M367.536 163.936C362.28 160.824 356.472 160.736 353.624 157.472C350.776 154.208 356.368 152.536 359.36 153.776C362.352 155.016 369.288 158.576 370.6 159.376C371.912 160.176 371.008 148.792 368.568 144.512C366.128 140.232 359.464 137.744 356.136 141.24C349.112 148.616 338.16 138.944 338.912 133.184C339.664 127.424 334.28 121.184 322.728 124.848C311.176 128.512 315.48 130.504 315.48 130.504C315.48 130.504 323.688 135.528 328.944 138.64C334.2 141.752 342.904 144.416 341.04 146.68C339.176 148.944 334.128 147.56 329.92 144.184C325.712 140.808 313.6 132.752 312.376 135.744C311.152 138.736 306.776 146.944 306.776 146.944C312.125 147.765 317.413 148.938 322.608 150.456C329.64 152.664 331.08 156.528 325.584 156.856C320.088 157.184 310.112 153.032 307 158.288C303.888 163.544 306.024 177.04 306.024 177.04C306.024 177.04 316.088 170.216 321.224 170.24C326.36 170.264 323.072 173.112 317.336 176.808C314.845 178.33 312.442 179.988 310.136 181.776L315.368 195.2C315.368 195.2 324 194.096 327.408 194.336L330.816 194.576C330.816 194.576 330.816 180.544 334.816 176.384C338.816 172.224 339.568 181.848 340.416 184.304C341.264 186.76 338.704 194.112 338.704 194.112C338.704 194.112 348.672 188.656 351.904 186.488L355.104 184.32C355.104 184.32 351.376 174.128 348.84 171.216C346.304 168.304 342.856 168.736 345.776 166.208C348.696 163.68 353.04 165.008 355.528 168.608C358.016 172.208 360.984 179.2 360.984 179.2C360.984 179.2 364.704 179.8 369.544 174.328C374.384 168.856 372.8 167.04 367.536 163.936ZM321.848 179.384C317.984 177.456 327.2 173.6 327.2 173.6C330.536 173.112 325.712 181.32 321.848 179.384ZM328.352 161.36C326.704 160.56 331.648 158.896 331.648 158.896C338.776 160.264 330 162.184 328.352 161.36Z",
    fill: "#407BFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M321.743 189.225C320.746 190.291 319.714 191.321 318.647 192.313",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M341.6 159.2C337.904 166.896 332.32 176.944 324.968 185.672",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M343.344 155.321C345.664 150.145 346.848 146.729 346.848 146.729C346.848 146.729 351.16 148.745 355.336 147.673C357.803 147.026 360.388 146.974 362.88 147.521",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M339.144 154.057C340.24 153.113 323.376 144.729 323.376 144.729",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M348 159.137C348 159.137 356 162.433 360.416 167.537",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M337.376 164.544C333.103 163.822 328.771 163.517 324.44 163.632C320.085 163.682 315.766 164.416 311.64 165.808",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M339.399 169.816C339.399 169.816 348.239 175.576 348.071 182.752",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M275.272 151.105C275.272 151.105 269.96 154.969 266.576 151.105C263.192 147.241 268 139.521 263.2 136.625C258.4 133.729 250.648 139.025 250.648 139.025C250.648 139.025 256.92 140.473 256.92 143.825C256.92 147.177 254.024 148.625 253.544 147.209C253.064 145.793 249.68 138.513 244.856 141.897C243.46 142.834 242.27 144.045 241.357 145.455C240.444 146.866 239.827 148.448 239.544 150.105C239.544 150.105 251.128 148.169 252.096 152.505C253.064 156.841 247.296 152.025 242.44 152.025C237.584 152.025 233.264 152.993 233.744 155.889C234.008 158.455 234.008 161.042 233.744 163.609C233.744 163.609 237.608 159.753 242.92 159.753C248.232 159.753 248.232 163.129 243.4 163.129C238.568 163.129 234.712 167.929 234.712 167.929C234.712 167.929 239.512 175.169 245.336 178.545C251.16 181.921 253.056 180.481 253.544 177.585C254.032 174.689 252.096 167.441 255.472 167.441C258.848 167.441 250.672 180.481 254.992 180.961C259.312 181.441 262.712 179.993 263.68 177.097L264.648 174.201C264.648 174.201 262.712 167.001 263.2 164.065C263.688 161.129 264.648 164.065 265.6 167.441C266.552 170.817 267.528 179.033 268.976 178.545C270.424 178.057 274.768 171.785 275.736 169.377C276.704 166.969 268.976 160.201 268.976 158.753C268.976 157.305 274.768 159.721 275.736 161.153C276.438 162.243 277.081 163.37 277.664 164.529C277.664 164.529 281.048 162.129 280.56 155.353C280.072 148.577 275.272 151.105 275.272 151.105Z",
    fill: "#407BFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M248.224 168.616C251.56 163.952 256.512 157.624 260.784 154.488",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M244.367 174.281C244.367 174.281 245.215 172.945 246.599 170.929",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M263.199 155.448C263.199 155.448 268.991 162.696 270.439 170.416",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M257.407 160.28C257.407 160.28 258.855 159.312 258.855 168.968",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M260.8 151.104C260.8 151.104 263.696 148.208 261.768 142.896",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M256.92 155.936L254.512 152.072",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M252.575 160.28C252.575 160.28 245.335 155.48 240.991 155.48",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M280.239 211.921C280.239 211.921 295.511 203.441 296.639 222.665C297.343 234.545 298.687 286.793 299.615 324.993",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M304.575 224.36C304.575 224.36 295.199 245.288 296.415 324.984",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M292.335 215.792C292.335 215.792 298.175 219.536 301.503 215.256C304.831 210.976 299.255 203.12 304.167 199.768C309.079 196.416 317.551 201.536 317.551 201.536C317.551 201.536 311.023 203.448 311.231 207.016C311.439 210.584 314.591 211.928 315.007 210.368C315.423 208.808 318.535 200.96 323.807 204.224C325.336 205.127 326.666 206.33 327.717 207.762C328.767 209.193 329.517 210.823 329.919 212.552C329.919 212.552 317.583 211.24 316.831 215.88C316.079 220.52 321.895 215.08 326.983 214.768C332.071 214.456 336.719 215.216 336.391 218.304C336.063 221.392 336.871 226.448 336.871 226.448C336.871 226.448 332.559 222.616 326.959 222.944C321.359 223.272 321.567 226.84 326.655 226.536C331.743 226.232 336.119 231.088 336.119 231.088C336.119 231.088 331.479 239.024 325.583 242.952C319.687 246.88 317.583 245.464 316.863 242.44C316.143 239.416 317.767 231.664 314.199 231.872C310.631 232.08 320.103 245.32 315.551 246.096C310.999 246.872 307.343 245.56 306.143 242.568L304.943 239.568C304.943 239.568 306.543 231.816 305.847 228.792C305.151 225.768 304.319 228.88 303.511 232.504C302.703 236.128 302.191 244.84 300.631 244.424C299.071 244.008 294.103 237.656 292.935 235.168C291.767 232.68 299.495 225.072 299.407 223.552C299.319 222.032 293.351 224.928 292.423 226.512C291.752 227.709 291.143 228.94 290.599 230.2C290.599 230.2 286.887 227.864 286.975 220.704C287.063 213.544 292.335 215.792 292.335 215.792Z",
    fill: "#407BFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M292.335 215.792C292.335 215.792 298.175 219.536 301.503 215.256C304.831 210.976 299.255 203.12 304.167 199.768C309.079 196.416 317.551 201.536 317.551 201.536C317.551 201.536 311.023 203.448 311.231 207.016C311.439 210.584 314.591 211.928 315.007 210.368C315.423 208.808 318.535 200.96 323.807 204.224C325.336 205.127 326.666 206.33 327.717 207.762C328.767 209.193 329.517 210.823 329.919 212.552C329.919 212.552 317.583 211.24 316.831 215.88C316.079 220.52 321.895 215.08 326.983 214.768C332.071 214.456 336.719 215.216 336.391 218.304C336.063 221.392 336.871 226.448 336.871 226.448C336.871 226.448 332.559 222.616 326.959 222.944C321.359 223.272 321.567 226.84 326.655 226.536C331.743 226.232 336.119 231.088 336.119 231.088C336.119 231.088 331.479 239.024 325.583 242.952C319.687 246.88 317.583 245.464 316.863 242.44C316.143 239.416 317.767 231.664 314.199 231.872C310.631 232.08 320.103 245.32 315.551 246.096C310.999 246.872 307.343 245.56 306.143 242.568L304.943 239.568C304.943 239.568 306.543 231.816 305.847 228.792C305.151 225.768 304.319 228.88 303.511 232.504C302.703 236.128 302.191 244.84 300.631 244.424C299.071 244.008 294.103 237.656 292.935 235.168C291.767 232.68 299.495 225.072 299.407 223.552C299.319 222.032 293.351 224.928 292.423 226.512C291.752 227.709 291.143 228.94 290.599 230.2C290.599 230.2 286.887 227.864 286.975 220.704C287.063 213.544 292.335 215.792 292.335 215.792Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M321.943 232.576C318.135 227.864 312.527 221.496 307.823 218.456",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M326.4 238.312C326.4 238.312 325.424 236.952 323.84 234.912",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M305.336 219.624C305.336 219.624 299.68 227.624 298.632 235.856",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M311.743 224.352C311.743 224.352 310.143 223.424 310.759 233.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M307.607 214.888C307.607 214.888 304.407 212.016 306.079 206.296",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M311.983 219.745L314.287 215.521",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M316.84 224.056C316.84 224.056 324.176 218.512 328.752 218.24",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M271.519 200.705C271.519 200.705 271.751 209.105 278.303 209.505C284.855 209.905 288.919 198.985 295.623 201.617C302.327 204.249 302.983 216.225 302.983 216.225C302.983 216.225 296.583 210.993 293.191 213.633C289.799 216.273 290.559 220.337 292.391 219.697C294.223 219.057 304.215 216.825 304.567 224.353C304.705 226.498 304.406 228.65 303.688 230.677C302.97 232.704 301.849 234.564 300.391 236.145C300.391 236.145 293.303 222.897 288.143 225.313C282.983 227.729 292.407 229.825 296.143 234.721C299.879 239.617 302.399 244.801 299.055 246.553C295.711 248.305 291.231 252.585 291.231 252.585C291.231 252.585 292.127 245.657 287.975 240.273C283.823 234.889 280.407 237.529 284.175 242.425C287.943 247.321 286.071 255.001 286.071 255.001C286.071 255.001 274.959 255.761 267.015 252.537C259.071 249.313 259.015 246.217 261.583 243.465C264.151 240.713 272.983 237.009 270.343 233.585C267.703 230.161 260.903 248.657 257.023 244.633C253.143 240.609 251.999 236.049 254.151 232.801L256.327 229.561C256.327 229.561 265.175 225.865 267.735 223.113C270.295 220.361 266.607 221.641 262.423 223.305C258.239 224.969 249.175 230.393 248.535 228.553C247.895 226.713 250.855 217.401 252.535 214.537C254.215 211.673 267.111 214.225 268.575 213.089C270.039 211.953 263.071 207.977 260.855 208.129C259.199 208.27 257.552 208.497 255.919 208.809C255.919 208.809 255.727 203.497 262.951 198.705C270.175 193.913 271.519 200.705 271.519 200.705Z",
    fill: "#407BFF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.519 200.705C271.519 200.705 271.751 209.105 278.303 209.505C284.855 209.905 288.919 198.985 295.623 201.617C302.327 204.249 302.983 216.225 302.983 216.225C302.983 216.225 296.583 210.993 293.191 213.633C289.799 216.273 290.559 220.337 292.391 219.697C294.223 219.057 304.215 216.825 304.567 224.353C304.705 226.498 304.406 228.65 303.688 230.677C302.97 232.704 301.849 234.564 300.391 236.145C300.391 236.145 293.303 222.897 288.143 225.313C282.983 227.729 292.407 229.825 296.143 234.721C299.879 239.617 302.399 244.801 299.055 246.553C295.711 248.305 291.231 252.585 291.231 252.585C291.231 252.585 292.127 245.657 287.975 240.273C283.823 234.889 280.407 237.529 284.175 242.425C287.943 247.321 286.071 255.001 286.071 255.001C286.071 255.001 274.959 255.761 267.015 252.537C259.071 249.313 259.015 246.217 261.583 243.465C264.151 240.713 272.983 237.009 270.343 233.585C267.703 230.161 260.903 248.657 257.023 244.633C253.143 240.609 251.999 236.049 254.151 232.801L256.327 229.561C256.327 229.561 265.175 225.865 267.735 223.113C270.295 220.361 266.607 221.641 262.423 223.305C258.239 224.969 249.175 230.393 248.535 228.553C247.895 226.713 250.855 217.401 252.535 214.537C254.215 211.673 267.111 214.225 268.575 213.089C270.039 211.953 263.071 207.977 260.855 208.129C259.199 208.27 257.552 208.497 255.919 208.809C255.919 208.809 255.727 203.497 262.951 198.705C270.175 193.913 271.519 200.705 271.519 200.705Z",
    fill: "#263238"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M274.896 241.792C277.016 234.768 279.568 224.8 279.408 218.024",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M272.168 250.12C272.168 250.12 272.864 248.208 273.824 245.232",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M276.543 216.329C276.543 216.329 264.679 216.113 255.743 220.681",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M276.175 225.968C276.175 225.968 276.023 223.752 266.239 231.288",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M282.832 215.384C282.832 215.384 283.504 210.184 290.4 207.992",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M280.96 223.064L286.76 222.496",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M279.943 230.864C279.943 230.864 290.495 234.432 293.887 238.864",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M341.888 256.601C341.888 256.601 319.2 271.609 311.544 324.801",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M300.744 250.777C300.744 250.777 301.808 260.441 309.408 260.297C317.008 260.153 320.664 247.153 328.648 249.561C336.632 251.969 338.52 265.721 338.52 265.721C338.52 265.721 330.672 260.289 326.968 263.657C323.264 267.025 324.568 271.657 326.64 270.729C328.712 269.801 340.008 266.297 341.12 274.953C341.482 277.415 341.342 279.925 340.707 282.331C340.071 284.738 338.954 286.99 337.424 288.953C337.424 288.953 328 274.337 322.264 277.601C316.528 280.865 327.608 282.401 332.416 287.697C337.224 292.993 340.504 298.713 336.848 301.073C333.192 303.433 328.384 308.801 328.384 308.801C328.384 308.801 328.768 300.721 323.472 294.905C318.176 289.089 314.472 292.449 319.288 297.745C324.104 303.041 322.664 312.081 322.664 312.081C322.664 312.081 309.912 314.009 300.44 311.025C290.968 308.041 290.616 304.489 293.312 301.073C296.008 297.657 305.864 292.553 302.496 288.849C299.128 285.145 293.024 307.137 288.168 302.857C283.312 298.577 281.52 293.433 283.736 289.481L285.944 285.537C285.944 285.537 295.808 280.433 298.496 277.017C301.184 273.601 297.056 275.417 292.384 277.745C287.712 280.073 277.768 287.177 276.848 285.113C275.928 283.049 278.448 272.025 280.16 268.561C281.872 265.097 296.96 266.817 298.56 265.361C300.16 263.905 291.728 259.977 289.184 260.361C287.296 260.681 285.427 261.1 283.584 261.617C283.584 261.617 282.856 255.505 290.744 249.297C298.632 243.089 300.744 250.777 300.744 250.777Z",
    fill: "#407BFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M300.744 250.777C300.744 250.777 301.808 260.441 309.408 260.297C317.008 260.153 320.664 247.153 328.648 249.561C336.632 251.969 338.52 265.721 338.52 265.721C338.52 265.721 330.672 260.289 326.968 263.657C323.264 267.025 324.568 271.657 326.64 270.729C328.712 269.801 340.008 266.297 341.12 274.953C341.482 277.415 341.342 279.925 340.707 282.331C340.071 284.738 338.954 286.99 337.424 288.953C337.424 288.953 328 274.337 322.264 277.601C316.528 280.865 327.608 282.401 332.416 287.697C337.224 292.993 340.504 298.713 336.848 301.073C333.192 303.433 328.384 308.801 328.384 308.801C328.384 308.801 328.768 300.721 323.472 294.905C318.176 289.089 314.472 292.449 319.288 297.745C324.104 303.041 322.664 312.081 322.664 312.081C322.664 312.081 309.912 314.009 300.44 311.025C290.968 308.041 290.616 304.489 293.312 301.073C296.008 297.657 305.864 292.553 302.496 288.849C299.128 285.145 293.024 307.137 288.168 302.857C283.312 298.577 281.52 293.433 283.736 289.481L285.944 285.537C285.944 285.537 295.808 280.433 298.496 277.017C301.184 273.601 297.056 275.417 292.384 277.745C287.712 280.073 277.768 287.177 276.848 285.113C275.928 283.049 278.448 272.025 280.16 268.561C281.872 265.097 296.96 266.817 298.56 265.361C300.16 263.905 291.728 259.977 289.184 260.361C287.296 260.681 285.427 261.1 283.584 261.617C283.584 261.617 282.856 255.505 290.744 249.297C298.632 243.089 300.744 250.777 300.744 250.777Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M308.52 297.865C310.304 289.561 312.312 277.825 311.48 270.009",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M306.159 307.728C306.159 307.728 306.783 305.464 307.607 301.944",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M308 268.328C308 268.328 294.288 269.2 284.384 275.312",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M308.503 279.489C308.503 279.489 308.119 276.937 297.535 286.569",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M315.199 266.64C315.199 266.64 315.487 260.576 323.199 257.4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M313.743 275.688L320.383 274.48",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M313.319 284.801C313.319 284.801 325.823 287.929 330.159 292.689",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M307.352 324.537L309.648 283.177",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M304.44 324.993C304.928 290.193 299.952 244.721 270.632 244.721",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M241.256 267.008C246.512 263.904 252.328 263.808 255.176 260.552C258.024 257.296 252.432 255.616 249.44 256.848C246.448 258.08 239.512 261.648 238.192 262.448C236.872 263.248 237.792 251.872 240.224 247.592C242.656 243.312 249.328 240.824 252.656 244.32C259.68 251.696 270.632 242.024 269.888 236.256C269.144 230.488 274.52 224.296 286.072 227.928C297.624 231.56 293.312 233.576 293.312 233.576C293.312 233.576 285.112 238.608 279.856 241.712C274.6 244.816 265.888 247.488 267.76 249.752C269.632 252.016 274.664 250.64 278.88 247.256C283.096 243.872 295.184 235.84 296.424 238.832C297.664 241.824 302.024 250.072 302.024 250.072C296.672 250.897 291.381 252.073 286.184 253.592C279.152 255.8 277.712 259.664 283.208 259.992C288.704 260.32 298.688 256.16 301.792 261.416C304.896 266.672 302.776 280.168 302.776 280.168C302.776 280.168 292.712 273.352 287.576 273.376C282.44 273.4 285.728 276.24 291.464 279.944C293.952 281.468 296.356 283.127 298.664 284.912L293.44 298.288C293.44 298.288 284.808 297.184 281.44 297.424L278.032 297.664C278.032 297.664 278.032 283.632 274.032 279.464C270.032 275.296 269.288 284.936 268.432 287.392C267.576 289.848 270.152 297.192 270.152 297.192C270.152 297.192 260.184 291.736 256.952 289.568L253.752 287.4C253.752 287.4 257.48 277.216 260.008 274.296C262.536 271.376 265.992 271.824 263.08 269.288C260.168 266.752 255.808 268.096 253.32 271.688C250.832 275.28 247.912 282.336 247.912 282.336C247.912 282.336 244.192 282.944 239.36 277.464C234.528 271.984 236 270.12 241.256 267.008ZM286.944 282.464C290.808 280.536 281.64 276.672 281.64 276.672C278.256 276.184 283.088 284.392 286.944 282.464ZM280.44 264.44C282.088 263.64 277.152 261.968 277.152 261.968C270.016 263.344 278.8 265.264 280.44 264.44Z",
    fill: "#407BFF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M287.048 292.296C288.056 293.363 289.088 294.395 290.144 295.392",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M267.239 262.257C270.927 269.953 276.519 279.993 283.871 288.729",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M265.448 258.401C263.136 253.225 261.944 249.809 261.944 249.809C261.944 249.809 257.64 251.825 253.456 250.753C250.992 250.103 248.408 250.05 245.92 250.601",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M269.647 257.137C268.559 256.185 285.415 247.809 285.415 247.809",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M260.8 262.208C260.8 262.208 252.8 265.512 248.384 270.616",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M271.416 267.616C275.691 266.894 280.026 266.589 284.36 266.705C288.714 266.755 293.034 267.49 297.16 268.881",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M269.391 272.896C269.391 272.896 260.591 278.656 260.719 285.832",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M333.527 254.184C333.527 254.184 338.839 258.048 342.215 254.184C345.591 250.32 340.799 242.6 345.599 239.696C350.399 236.792 358.151 242.096 358.151 242.096C358.151 242.096 351.871 243.544 351.871 246.896C351.871 250.248 354.767 251.696 355.255 250.272C355.743 248.848 359.111 241.584 363.943 244.96C365.336 245.9 366.525 247.111 367.438 248.522C368.351 249.932 368.969 251.513 369.255 253.168C369.255 253.168 357.663 251.24 356.703 255.568C355.743 259.896 361.503 255.088 366.359 255.088C371.215 255.088 375.527 256.048 375.047 258.944C374.787 261.514 374.787 264.103 375.047 266.672C375.047 266.672 371.183 262.808 365.871 262.808C360.559 262.808 360.559 266.192 365.391 266.192C370.223 266.192 374.079 270.992 374.079 270.992C374.079 270.992 369.279 278.192 363.463 281.616C357.647 285.04 355.735 283.544 355.255 280.648C354.775 277.752 356.703 270.512 353.319 270.512C349.935 270.512 358.119 283.544 353.807 284.032C349.495 284.52 346.079 283.064 345.111 280.168L344.151 277.272C344.151 277.272 346.079 270.112 345.599 267.2C345.119 264.288 344.151 267.2 343.199 270.584C342.247 273.968 341.263 282.168 339.815 281.688C338.367 281.208 334.023 274.928 333.063 272.512C332.103 270.096 339.815 263.344 339.815 261.896C339.815 260.448 334.023 262.856 333.063 264.296C332.359 265.39 331.713 266.519 331.127 267.68C331.127 267.68 327.751 265.28 328.231 258.504C328.711 251.728 333.527 254.184 333.527 254.184Z",
    fill: "#407BFF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M360.576 271.697C357.24 267.033 352.288 260.697 348.008 257.561",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M364.423 277.361C364.423 277.361 363.575 276.017 362.191 274.009",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M345.6 258.528C345.6 258.528 339.8 265.728 338.352 273.496",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M351.391 263.36C351.391 263.36 349.943 262.392 349.943 272.048",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M348 254.185C348 254.185 345.104 251.289 347.04 245.977",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M351.871 259.008L354.287 255.152",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M356.216 263.361C356.216 263.361 363.464 258.561 367.808 258.561",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M223.999 27.8242H46.3994V261.696H223.999V27.8242Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M218.4 21.4238H40.7998V255.296H218.4V21.4238Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M171.679 91.672H50.3994V64.416H207.775V91.672H174.607",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2234 123.912H50.3994V109.824H136.303",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M140.032 109.824H207.776V123.912H62.8877",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M183.119 152.424H50.3994V138.336H207.775V152.424H186.047",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0874 237.632H50.3994V165.888H207.775V237.632H95.0714",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M207.775 165.888H50.3994V178.424H207.775V165.888Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M125.207 92.1999V109.848H50.3994V91.6719",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M207.775 74.0879H50.3994V81.9999H207.775V74.0879Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M155.527 65.1514V74.1274",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M175.76 66.6562H165.04V71.8963H175.76V66.6562Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M130.479 82.248V91.76",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M163.384 82.248V91.76",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3516 109.848V91.7998",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6719 109.848V91.7998",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M117.647 109.936V123.664",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M155.168 109.744V152.184",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3994 123.912V138.352H155.223",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8799 124.016V137.904",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M198.552 190.104H207.856",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6162 190.104H195.088",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6162 201.432H207.856",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0635 212.712H207.855",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6162 212.712H95.0722",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5602 193.224H75.2402V198.544H80.5602V193.224Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M111.08 193.224H105.76V198.544H111.08V193.224Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9997 204.08H84.6797V209.4H89.9997V204.08Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M119.175 204.08H113.855V209.4H119.175V204.08Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M147.064 204.08H141.744V209.4H147.064V204.08Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M175.383 204.08H170.063V209.4H175.383V204.08Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2158 201.527V212.815",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M110.752 201.527V212.815",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M139.28 201.527V212.815",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M167.808 201.527V212.815",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6162 224.216H207.856",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4802 215.584H65.1602V220.904H70.4802V215.584Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M119.175 215.584H113.855V220.904H119.175V215.584Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M147.064 215.584H141.744V220.904H147.064V215.584Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M183 215.584H177.68V220.904H183V215.584Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6963 213.032V224.2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M110.752 213.032V224.2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M139.28 213.032V224.2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M175.424 213.032V224.2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M113.744 40.3198V42.2558H109.352V50.5278H107.2V31.4238H114.792V33.3598H109.336V40.3198H113.744Z",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M116.336 36.0402C116.336 33.1202 117.776 31.2402 120.696 31.2402C123.616 31.2402 125.088 33.1282 125.088 36.0402V45.9122C125.088 48.8082 123.648 50.7122 120.696 50.7122C117.744 50.7122 116.336 48.8002 116.336 45.9122V36.0402ZM118.4 46.0242C118.4 47.7682 119.136 48.7842 120.664 48.7842C122.192 48.7842 122.928 47.7682 122.928 46.0242V35.9282C122.928 34.2082 122.224 33.1682 120.664 33.1682C119.104 33.1682 118.4 34.2082 118.4 35.9282V46.0242Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M131.368 31.4238C134.368 31.4238 135.624 32.9518 135.624 35.7918V37.3438C135.624 39.4478 134.888 40.7598 133.224 41.2798C134.968 41.7918 135.624 43.2158 135.624 45.2798V48.2558C135.562 49.0411 135.693 49.8296 136.008 50.5518H133.856C133.552 49.8184 133.428 49.0228 133.496 48.2318V45.2078C133.496 43.0478 132.488 42.3678 130.712 42.3678H129.216V50.5278H127.088V31.4238H131.368ZM130.824 40.4318C132.512 40.4318 133.52 39.8878 133.52 37.8078V35.9998C133.52 34.2798 132.896 33.3758 131.312 33.3758H129.24V40.4478L130.824 40.4318Z",
    fill: "#263238"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M144.896 50.4958H142.856L139.656 35.2958V50.4958H137.8V31.4238H140.8L143.936 46.6798L146.968 31.4238H149.936V50.5278H147.92V35.1998L144.896 50.4958Z",
    fill: "#263238"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2637 59.8799H115.592",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9922 59.8799H95.3442",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M129.271 59.8799H167.463",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M177.84 59.8799H208.016",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M184.752 330.04L244.128 327.6L276.552 367.008L196.48 373.984L184.752 330.04Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M196.743 357.176L260.927 352.704L265.159 358.032L198.527 363.096L196.743 357.176Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M194.815 350.776L256.327 346.904L258.287 349.376L195.639 353.504L194.815 350.776Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 345.6L252.584 342.184L254.4 344.472L194.008 348.104L193.256 345.6Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M189.248 332.296L242.88 329.96L250.912 340.08L192.56 343.288L189.248 332.296Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M191.936 341.216L249.4 338.176L250.912 340.08L192.56 343.288L191.936 341.216Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M231.464 354.648L229.552 351.264L258.288 349.376L260.928 352.704",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M197.359 359.216L262.391 354.544L263.623 356.088L197.879 360.936L197.359 359.216Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M221.647 361.168L220.743 359.24",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M212.208 360.367L216.872 360.023L217.368 361.151L212.672 361.511L212.208 360.367Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M230.415 356.792L229.367 354.888",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M216.616 357.784L215.752 355.832",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M247.384 350.088L249.76 353.456",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M240.344 350.552L242.552 353.96",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M232.536 351.048L231.056 348.544",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M217.535 352.072L213.951 344.448",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M256.328 346.904L254.4 344.472L215.048 346.84",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M241.632 347.816L240.016 345.416",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M247.968 336.464L191.344 339.352",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M246.68 334.848L190.808 337.592",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M245.44 333.28L190.296 335.888",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M236.84 335.76L238.656 335.672L239.208 336.44L237.376 336.528L236.84 335.76Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M226.231 336.287L228.095 336.191L228.583 336.975L226.711 337.071L226.231 336.287Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M232.535 334.368L234.351 334.28L234.871 335.032L233.047 335.12L232.535 334.368Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M222.464 334.848L224.32 334.76L224.776 335.528L222.912 335.616L222.464 334.848Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M212.624 335.319L214.52 335.231L214.912 336.007L213.008 336.095L212.624 335.319Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M202.424 335.808L204.352 335.72L204.688 336.504L202.744 336.6L202.424 335.808Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M235.967 335.36L234.855 333.768",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M226.088 335.84L225.096 334.224",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M215.992 336.336L215.136 334.696",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M205.671 336.848L204.951 335.176",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M244.208 331.728L189.792 334.2",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M238 332.472L239.768 332.392L240.304 333.112L238.536 333.2L238 332.472Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M221.52 333.232L223.344 333.144L223.792 333.888L221.952 333.976L221.52 333.232Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M211.808 333.672L213.672 333.592L214.064 334.344L212.184 334.432L211.808 333.672Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M199 334.264L200.92 334.176L201.224 334.944L199.296 335.032L199 334.264Z",
    fill: "#D1D1D1",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M241.392 333.424L240.248 331.904",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M225.08 334.2L224.136 332.64",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M215.12 334.664L214.296 333.088",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M202.191 335.28L201.535 333.672",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M242.663 365.28L242.399 364.84L244.287 364.688L243.151 362.84L244.055 362.768L246.735 367.104L243.431 367.384L243.167 366.928L245.567 366.728L244.583 365.128L242.663 365.28Z",
    fill: "#263238"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M242.127 366.4C242.535 367.08 242.127 367.576 240.879 367.688C239.631 367.8 238.687 367.408 238.303 366.72L237.023 364.448C236.655 363.8 237.023 363.32 238.295 363.224C239.567 363.128 240.415 363.496 240.791 364.144L242.127 366.4ZM239.879 364.192C239.734 363.981 239.53 363.817 239.292 363.722C239.055 363.626 238.794 363.603 238.543 363.656C237.879 363.704 237.703 363.96 237.927 364.352L239.247 366.664C239.391 366.886 239.599 367.058 239.843 367.16C240.087 367.261 240.356 367.286 240.615 367.232C241.279 367.176 241.463 366.904 241.231 366.504L239.879 364.192Z",
    fill: "#263238"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M236.136 368C234.8 368.112 234.048 367.792 233.696 367.12L233.496 366.76C233.24 366.272 233.4 365.96 234.056 365.76C233.75 365.779 233.445 365.715 233.173 365.574C232.901 365.433 232.672 365.221 232.512 364.96L232.152 364.288C232.061 364.078 231.908 363.902 231.712 363.784L232.648 363.704C232.838 363.829 232.988 364.007 233.08 364.216L233.448 364.896C233.72 365.392 234.248 365.512 235.048 365.448L235.704 365.4L234.688 363.552L235.6 363.472L238.056 367.872L236.136 368ZM235.2 365.864C234.464 365.928 234.088 366.088 234.344 366.576L234.576 367C234.792 367.408 235.184 367.592 235.888 367.536L236.808 367.464L235.896 365.808L235.2 365.864Z",
    fill: "#263238"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M227.855 364.064L228.751 363.992L231.951 367.392L230.127 363.872L230.927 363.808L233.247 368.24L231.919 368.352L228.719 364.896L229.159 368.592L227.815 368.704L225.647 364.232L226.527 364.16L228.287 367.728L227.855 364.064Z",
    fill: "#263238"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M265.663 358.976L239.287 361.008",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M233.504 361.456L216.96 362.728",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M212.36 363.088L198.728 364.136",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M239.999 204.264C234.323 205.944 228.792 208.084 223.463 210.664C214.663 214.936 197.335 221.336 189.063 224.536C180.791 227.736 175.735 236 174.135 240C172.535 244 165.599 261.064 165.599 261.064C165.599 261.064 150.935 284 147.199 289.6C143.463 295.2 138.399 302.936 138.135 310.136C137.871 317.336 141.863 321.336 151.199 321.336C160.535 321.336 164.535 318.136 169.063 313.336C173.591 308.536 188.263 285.064 190.399 282.4C192.535 279.736 198.399 269.6 198.399 269.6C198.399 269.6 201.335 296 201.335 304.264V323.736H285.335C285.335 323.736 289.335 294.4 290.135 292C290.935 289.6 297.063 272.264 297.063 272.264C297.063 272.264 319.199 308 322.895 312.8C326.591 317.6 337.143 327.712 347.479 323.664C357.815 319.616 355.695 308.528 350.095 295.2C344.495 281.872 334.663 259.2 334.663 258.12C334.663 257.04 330.663 241.32 314.399 229.048C298.135 216.776 282.135 213.848 278.399 211.984C274.663 210.12 262.663 204.264 239.999 204.264Z",
    fill: "#407BFF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M187.736 252.264L198.136 268.536C198.136 268.536 189.6 259.736 184.264 258.4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M198.135 268.536L191.999 266.4C191.999 266.4 186.399 263.2 181.863 264.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M230.031 229.6C230.631 233.992 232.015 239.448 235.199 243.2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M229.6 222.399C229.6 222.399 229.544 223.927 229.688 226.231",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M232.52 246.399C233.271 247.167 234.073 247.883 234.92 248.543",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M225.063 234.399C226.52 238.348 228.668 242.005 231.407 245.199",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M277.736 293.983C275.92 296.935 274.2 299.319 272.8 300.535",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M291.199 267.464C291.199 267.464 284.999 281.48 279.199 291.464",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M263.936 302.76C263.136 303.728 262.52 304.536 262.136 305.064",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M274.136 290.664C274.136 290.664 269.224 296.376 265.6 300.8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M297.063 272.264C297.063 272.264 308.799 253.6 309.335 252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M306.04 265.072C309.528 262.248 314.768 258.672 320 257.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M301.863 268.799C301.863 268.799 302.815 267.815 304.415 266.399",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M316.536 254.664C313.162 256.424 309.949 258.477 306.936 260.8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M321.336 294.136C323.612 293.055 326.122 292.562 328.638 292.702C331.153 292.842 333.594 293.61 335.736 294.936",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M323.735 290.663C323.735 290.663 333.063 288.799 339.999 293.063",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M148.8 293.863C150.408 292.406 152.315 291.317 154.388 290.673C156.46 290.029 158.649 289.846 160.8 290.135",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M165.312 290.76C165.967 291.227 166.597 291.729 167.2 292.264",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M158.136 287.736C159.663 287.927 161.145 288.387 162.512 289.096",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M238.135 211.2C238.135 211.2 235.735 221.336 236.535 228.8C237.335 236.264 245.599 247.736 252.535 250.4C259.471 253.064 272.263 245.336 276.799 240.8C281.335 236.264 281.599 221.864 281.599 221.864C281.599 221.864 274.687 206.936 259.999 202.664C245.311 198.392 238.135 211.2 238.135 211.2Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M293.28 209.112C293.28 209.112 294.672 213.28 291.992 218.552C289.312 223.824 284.136 228.28 282.744 227.824C281.352 227.368 287.072 208.288 287.072 208.288C287.072 208.288 290.872 206.152 293.28 209.112Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M234.448 193.88C234.448 193.88 231.816 197.392 232.688 203.248C233.56 209.104 237.08 214.952 238.544 214.952C240.008 214.952 240.592 195.056 240.592 195.056C240.592 195.056 237.664 191.832 234.448 193.88Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M238.839 201.488C238.839 201.488 236.791 219.344 239.127 226.664C241.463 233.984 246.151 245.392 253.471 248.32C260.791 251.248 277.471 238.664 280.103 233.688C282.735 228.712 290.055 207.64 290.055 207.64C291.98 205.077 293.231 202.072 293.692 198.901C294.153 195.729 293.811 192.492 292.695 189.488C288.887 178.952 268.399 172.512 259.895 172.808C251.391 173.104 242.919 180.128 242.335 185.688C241.751 191.248 238.839 201.488 238.839 201.488Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M257.863 212.32C257.863 212.32 251.423 204.416 245.567 207.056",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M268.104 215.832C268.104 215.832 276.904 213.784 280.984 217.592",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M246.447 214.08C246.447 214.08 248.327 219.68 255.959 219.032",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M267.52 221.976C267.52 221.976 269.28 225.784 277.472 224.32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M253.096 227.304C252.837 228.489 253.007 229.728 253.576 230.8C254.528 232.232 256.912 234.296 258.664 234.296C260.416 234.296 264.072 233.664 265.024 232.696C265.635 232.068 266.171 231.373 266.624 230.624",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M249.119 232.552C249.119 232.552 253.119 237.16 256.439 238.272C259.759 239.384 265.975 237.472 267.727 236.84",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M307.087 181.344C306.815 179.424 308.183 176.68 308.455 175.04C308.727 173.4 306.535 170.376 304.623 167.912C303.145 165.939 302.371 163.528 302.423 161.064C302.423 159.416 300.511 158.048 298.863 156.952C296.86 155.618 295.02 154.053 293.383 152.288C292.287 150.92 287.631 151.192 286.807 151.192C285.983 151.192 282.423 148.184 280.231 147.088C278.039 145.992 273.655 147.888 273.655 147.888C273.655 147.888 268.447 145.424 267.351 145.424C266.255 145.424 261.591 147.344 261.591 147.344C260.047 148.006 258.439 148.507 256.791 148.84C256.493 148.762 256.187 148.711 255.879 148.688C255.263 147.888 249.783 151.176 249.783 151.176L244.855 151.976L243.023 154.944C241.271 155.136 237.167 155.792 236.879 157.8C236.511 160.36 236.879 161.456 235.783 162.912C234.687 164.368 230.671 164.008 231.783 167.296C232.895 170.584 235.431 173.144 232.143 174.976C228.855 176.808 227.031 180.088 228.855 181.912C230.679 183.736 232.143 186.296 231.783 187.76C231.423 189.224 231.047 192.512 232.511 193.24C233.801 193.987 235.024 194.843 236.167 195.8L237.991 199.8L239.087 202.36C239.087 202.36 240.911 196.512 242.375 195.784C243.839 195.056 242.375 198.344 245.303 198.344C248.231 198.344 251.143 184.456 253.303 184.088C255.463 183.72 262.103 196.152 268.655 196.152C275.207 196.152 283.303 190.4 286.599 190.4C289.895 190.4 287.327 204.28 287.327 207.2C287.327 210.12 288.055 213.04 288.055 214.144C288.055 215.248 291.711 209.024 294.271 207.56C294.975 207.16 295.823 206.672 296.711 206.112C296.711 206.24 296.671 206.312 296.671 206.312C296.671 206.312 305.719 200.552 306.815 198.64C307.911 196.728 307.087 195.072 307.087 193.432C307.087 191.792 308.183 190.416 308.455 187.952C308.727 185.488 307.359 183.256 307.087 181.344Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M374.072 323.672H21.5996",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M335.751 300.352C335.751 300.352 325.759 296.68 318.575 299.552C311.391 302.424 294.527 309.248 283.047 311.4C272.276 313.308 261.328 314.029 250.399 313.552C240.703 313.192 235.319 314.632 233.167 316.424C231.015 318.216 223.119 328.264 223.831 329.344C224.543 330.424 225.343 330.832 228.863 330.064C230.263 329.752 234.247 325.4 234.247 325.4L241.447 322.2C241.447 322.2 233.911 330.456 234.983 331.528C236.055 332.6 237.855 331.168 239.295 330.096C240.735 329.024 243.599 326.504 243.599 326.504L250.063 323.632C250.063 323.632 243.199 328.264 243.199 330.4C243.199 332.536 244.871 331.28 247.719 330.144C249.069 329.292 250.356 328.343 251.567 327.304L256.967 325.784C260.454 327.602 264.339 328.526 268.271 328.472C272.382 328.454 276.353 326.974 279.471 324.296C279.471 324.296 304.599 327.888 317.159 326.808C329.719 325.728 345.511 327.168 351.975 322.504C358.439 317.84 350.183 305.632 349.463 304.552",
    fill: "#ABABAB"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M335.751 300.352C335.751 300.352 325.759 296.68 318.575 299.552C311.391 302.424 294.527 309.248 283.047 311.4C272.276 313.308 261.328 314.029 250.399 313.552C240.703 313.192 235.319 314.632 233.167 316.424C231.015 318.216 223.119 328.264 223.831 329.344C224.543 330.424 225.343 330.832 228.863 330.064C230.263 329.752 234.247 325.4 234.247 325.4L241.447 322.2C241.447 322.2 233.911 330.456 234.983 331.528C236.055 332.6 237.855 331.168 239.295 330.096C240.735 329.024 243.599 326.504 243.599 326.504L250.063 323.632C250.063 323.632 243.199 328.264 243.199 330.4C243.199 332.536 244.871 331.28 247.719 330.144C249.069 329.292 250.356 328.343 251.567 327.304L256.967 325.784C260.454 327.602 264.339 328.526 268.271 328.472C272.382 328.454 276.353 326.974 279.471 324.296C279.471 324.296 304.599 327.888 317.159 326.808C329.719 325.728 345.511 327.168 351.975 322.504C358.439 317.84 350.183 305.632 349.463 304.552",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M225.496 330.336C225.496 330.336 226.832 326.488 228.168 324.816C229.504 323.144 235.688 319.136 237.864 317.968C238.727 317.469 239.619 317.022 240.536 316.632",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M241.407 322.168L247.719 317.968",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M250.023 323.6L255.911 320.64",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M335.752 300.351C330.416 299.079 322.88 297.831 318.576 299.551C312.176 302.103 298.192 307.759 287.096 310.503C288.668 312.233 289.578 314.463 289.664 316.799C289.789 319.727 289.388 322.654 288.48 325.439C296.936 326.391 309.416 327.495 317.144 326.831C329.704 325.751 345.496 327.191 351.96 322.527C358.424 317.863 350.168 305.655 349.448 304.575",
    fill: "#407BFF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M335.752 300.351C330.416 299.079 322.88 297.831 318.576 299.551C312.176 302.103 298.192 307.759 287.096 310.503C288.668 312.233 289.578 314.463 289.664 316.799C289.789 319.727 289.388 322.654 288.48 325.439C296.936 326.391 309.416 327.495 317.144 326.831C329.704 325.751 345.496 327.191 351.96 322.527C358.424 317.863 350.168 305.655 349.448 304.575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M146.239 299.272C146.911 297.456 151.839 293.112 158.471 294.272C165.103 295.432 172.631 302.8 176.935 308.464C181.239 314.128 184.671 315.664 184.671 315.664L179.599 331.16C179.599 331.16 176.479 330.408 170.623 328.92C164.767 327.432 151.663 325.496 145.639 323.624C139.615 321.752 137.047 315.272 138.359 309.224C139.028 305.863 140.173 302.614 141.759 299.576",
    fill: "#407BFF"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M146.239 299.272C146.911 297.456 151.839 293.112 158.471 294.272C165.103 295.432 172.631 302.8 176.935 308.464C181.239 314.128 184.671 315.664 184.671 315.664L179.599 331.16C179.599 331.16 176.479 330.408 170.623 328.92C164.767 327.432 151.663 325.496 145.639 323.624C139.615 321.752 137.047 315.272 138.359 309.224C139.028 305.863 140.173 302.614 141.759 299.576",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M176.936 308.464C176.48 307.872 175.992 307.264 175.48 306.64C171.728 308.136 166.968 310.896 164.448 315.76C161.928 320.624 161.912 324.64 162.4 327.2C165.6 327.808 168.552 328.384 170.608 328.904C176.464 330.392 179.584 331.144 179.584 331.144L184.656 315.648C184.656 315.648 181.232 314.136 176.936 308.464Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M174.863 323.6C174.527 326 173.791 328.744 177.263 330.264C180.735 331.784 184.191 335.536 186.375 336.416C189.017 337.428 191.779 338.095 194.591 338.4C196.815 338.544 199.559 339.272 203.919 338.056C208.279 336.84 208.159 335.72 208.159 335.72C208.159 335.72 210.879 335.824 212.223 335.16C213.567 334.496 212.623 332.832 210.991 332.176C209.359 331.52 207.359 330.64 207.359 330.64C207.359 330.64 209.839 328.352 209.215 327.784L208.599 327.216C208.599 327.216 211.463 327.552 211.711 326.64C211.959 325.728 210.159 321.696 209.439 318.304C208.719 314.912 207.207 315.368 204.447 314.824C201.687 314.28 197.927 314.976 192.967 313.92C188.007 312.864 180.823 314.64 177.983 315.392",
    fill: "#ABABAB"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M174.863 323.6C174.527 326 173.791 328.744 177.263 330.264C180.735 331.784 184.191 335.536 186.375 336.416C189.017 337.428 191.779 338.095 194.591 338.4C196.815 338.544 199.559 339.272 203.919 338.056C208.279 336.84 208.159 335.72 208.159 335.72C208.159 335.72 210.879 335.824 212.223 335.16C213.567 334.496 212.623 332.832 210.991 332.176C209.359 331.52 207.359 330.64 207.359 330.64C207.359 330.64 209.839 328.352 209.215 327.784L208.599 327.216C208.599 327.216 211.463 327.552 211.711 326.64C211.959 325.728 210.159 321.696 209.439 318.304C208.719 314.912 207.207 315.368 204.447 314.824C201.687 314.28 197.927 314.976 192.967 313.92C188.007 312.864 180.823 314.64 177.983 315.392",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M194.231 300.519L198.759 316.519L202.375 318.239L197.015 299.712C196.959 299.515 196.862 299.332 196.73 299.176C196.597 299.02 196.434 298.894 196.249 298.806C196.064 298.719 195.863 298.671 195.659 298.667C195.454 298.663 195.251 298.703 195.063 298.783C194.736 298.921 194.47 299.173 194.317 299.493C194.164 299.813 194.133 300.178 194.231 300.519Z",
    fill: "#263238"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M196.799 315.296C196.799 315.296 204.719 319.52 205.263 319.736C205.639 319.888 209.167 325.784 210.287 328.616C210.807 329.912 210.223 330.656 209.007 331.328L207.367 330.664L197.519 324.464L193.911 322.744",
    fill: "#ABABAB"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M196.799 315.296C196.799 315.296 204.719 319.52 205.263 319.736C205.639 319.888 209.167 325.784 210.287 328.616C210.807 329.912 210.223 330.656 209.007 331.328L207.367 330.664L197.519 324.464L193.911 322.744",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M191.271 329.096C191.271 329.096 198.983 333.68 200.607 334.52C202.231 335.36 208.159 335.744 208.159 335.744",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M188.384 333.6C188.384 333.6 194.856 337.168 196.128 337.6C197.4 338.032 200.128 338.784 200.128 338.784",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M138.272 363.336L167.808 336.168L102.736 331.968L138.272 363.336Z",
    fill: "#CCCCCC",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M137.024 357.864L150.32 345.264L134.92 344.336L137.024 357.864Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M46.464 287.04L143.88 291.352L138.272 363.336L40 358.592L46.464 287.04Z",
    fill: "#A6A6A6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4316 353.8C46.1916 352.952 55.9116 350.688 72.3276 345.376C111.408 332.728 116.328 297.376 143.88 291.352L46.4636 287.04L40.4316 353.8Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2962 329.28C95.4229 329.28 98.7682 326.708 98.7682 323.536C98.7682 320.364 95.4229 317.792 91.2962 317.792C87.1696 317.792 83.8242 320.364 83.8242 323.536C83.8242 326.708 87.1696 329.28 91.2962 329.28Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebForm4);
export default __webpack_public_path__ + "static/media/web-form4.e9c77806621705c6090b25843e5d3a22.svg";
export { ForwardRef as ReactComponent };